import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthenticationService } from '@app/core/authentication/authentication.service';
import {
  AdyenPayoutMethodCreateRequest,
  PayoutMethod,
  PayoutMethodsService,
} from '../../services/payout-methods.service';

@Component({
  standalone: false,
  templateUrl: './direct-payouts-methods-add-adyen.component.html',
  styleUrls: ['./direct-payouts-methods-add-adyen.component.scss'],
})
export class DirectPayoutsMethodsAddAdyenComponent implements OnInit {
  ADYEN_ALLOWABLE_COUNTRIES = {
    US: 'United States',
    GB: 'United Kingdom',
    AU: 'Australia',
    PR: 'Puerto Rico',
    VI: 'Virgin Islands, U.S.',
  };

  stage:
    | 'introduction'
    | 'entity_type'
    | 'individual_bank_account_owner'
    | 'organization_bank_account_owner'
    | 'property_selection'
    | 'property_warning'
    | 'saving'
    | 'success' = 'introduction';

  payoutMethod: AdyenPayoutMethodCreateRequest = {
    legal_entity: null,
    first_name: null,
    last_name: null,
    legal_name: null,
    phone: null,
    country: 'US',
    all_properties: false,
    properties: [],
  };
  overlappingProperties: any[];

  user = this.auth.getUserDetails();

  redirect: string = '';

  constructor(
    private payoutMethodsService: PayoutMethodsService,
    private auth: AuthenticationService,
    private route: ActivatedRoute,
    private router: Router
  ) { }

  ngOnInit(): void {
    if (this.user?.phone) {
      this.payoutMethod.phone = this.user.phone;
    }

    this.redirect = this.route.snapshot.queryParamMap.get('redirect');
  }

  progressFromEntityType(): void {
    if (this.payoutMethod.legal_entity === 'individual') {
      this.stage = 'individual_bank_account_owner';
    }

    if (this.payoutMethod.legal_entity === 'organization') {
      this.stage = 'organization_bank_account_owner';
    }
  }

  progressFromBankDetails() {
    // If we don't have any existing PREMIUM payout methods set as default, then we should skip property selection, and set all_properties as true ourselves
    this.payoutMethodsService.fetchPayoutMethods().subscribe((payouts: PayoutMethod[]) => {
      let premiumPayouts = payouts.filter((payout) => {
        return payout.provider === 'adyen';
      });

      let defaultPayout = premiumPayouts.find((payout) => {
        return payout.all_properties;
      });

      if (!defaultPayout) {
        this.payoutMethod.all_properties = true;
        this.progressToSaving();
      } else {
        this.stage = 'property_selection';
      }
    });
  }

  async checkForOverlappingProperties() {
    this.overlappingProperties = await this.payoutMethodsService.checkForOverlappingProperties(this.payoutMethod);

    if (this.overlappingProperties.length > 0) {
      this.stage = 'property_warning';
    } else {
      this.progressToSaving();
    }
  }

  updateDefaultPayoutMethod(isDefault: boolean) {
    this.payoutMethod.all_properties = isDefault;
  }

  setProperties(event) {
    this.payoutMethod.properties = event.properties;
  }

  progressToSaving() {
    this.stage = 'saving';

    this.payoutMethodsService.createAdyenPayoutMethod(this.payoutMethod).subscribe(
      (res: any) => {
        if (res?.uuid) {
          this.payoutMethod.uuid = res.uuid;
          this.progressToSuccess();
        }
      },
      (err) => {
        this.stage = 'property_selection';
      }
    );
  }

  progressToSuccess() {
    if (this.redirect) {
      switch (this.redirect) {
        case 'activate':
          this.router.navigate(['/direct/plan'], { queryParams: { open: 'activate' } });
          break;

        case 'switch':
          this.router.navigate(['/direct/plan'], { queryParams: { open: 'switch' } });
          break;

        default:
          break;
      }
    } else {
      this.stage = 'success';
    }
  }

  verifyClicked() {
    this.payoutMethodsService.adyenGetVerifyLink(this.payoutMethod.uuid).subscribe((res) => {
      if (res.data.url) {
        window.open(res.data.url, '_blank');
      }
    });
  }
}
